import { render, staticRenderFns } from "./LoteProducaoCortinaGrafico.vue?vue&type=template&id=638e5c38&"
import script from "./LoteProducaoCortinaGrafico.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoCortinaGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports